import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import FleetService from '../../../services/FleetService';

class VehicleType extends Component {

  isMobile = false;

  vehicleTypeData = [];

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      controls: props.controls || {},
      fleetData: props.fleetData || []
    };
    this.getVehicleType(); // get vehicle type data
  }

  async getVehicleType() {

    try {
      const { fleetData } = this.state;

      const { data } = await FleetService.getVehicleType();
      if (data) {
        this.vehicleTypeData = data.data;
      }

      if (fleetData.length < 2) {
        _.forEach(this.vehicleTypeData || [], element => {
          if (!_.some(fleetData || [], { type: (element.name || '') })) {
            fleetData.push({
              type: element.name,
              type_image_url: element.image_url,
              data: [],
              data_length: 0
            });
          }
        });
      }

      this.setState((prevState) => {
        return { ...prevState, fleetData };
      });

      this.props.updateState({ visibleArea: 'vehicleType', fleetData });

    } catch (error) {
      console.log(error);
    }
  }


  vehicleTypeClick(type) {
    const { controls } = this.state;
    controls.vehicleType.value = type;
    this.setState({ controls });
    this.props.updateState({ visibleArea: 'vehicleMake', controls });
  }

  render() {
    return (
      <div>
        <Row className="fleet-customer-details-label">
          <Col xl="10" xs="10" ms="10" className={classnames({ 'text-align-center': this.isMobile })} style={{ display: 'flex' }}>
            <span style={{ marginTop: '2px' }}>TYPE OF VEHICLE</span>
          </Col>
          <Col>
            <FontAwesomeIcon className="pull-right" onClick={this.props.onCancelClick} icon={faTimes} style={{ fontSize: '20px', cursor: 'pointer' }} color="#fdbb1f" />
          </Col>
        </Row>
        <div>
          <hr />
          <Row>
            <Col>
              <div>
                <span className="input-label" style={{ fontSize: '16px' }}>Please select your type of vehicle</span>
                <div className="d-flex-row" style={{ flexWrap: 'wrap', marginTop: '20px' }}>
                  {
                    (this.vehicleTypeData || []).map((type) => {
                      return (
                        <button type="button" onClick={() => this.vehicleTypeClick(type)} key={type.name} className="mb-2 mr-2 btn-icon btn btn-outline-secondary custom-secondary d-flex-column" style={{ width: '130px', height: '130px', borderRadius: '25px', justifyContent: 'space-between', display: 'flex', paddingTop: '20px' }}>
                          <span className="input-label" style={(type.name || '').toLowerCase() === 'bus' ? { color: '#6e777f', marginLeft: '32px' } : { color: '#6e777f', marginLeft: '30px' }}>
                            {type.name}
                          </span>
                          <br />
                          <img src={type.image_url} alt={type.name} className="type-image" style={(type.name || '').toLowerCase() === 'bus' ? { marginTop: '30px', marginLeft: '-15px', position: 'absolute' } : {}} />
                        </button>
                      );
                    })
                  }
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default VehicleType;